import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        cancelBtn: {
            '& .container-btn': {
                gap: '10px',
                justifyContent: 'space-between'
            },
            '& .cancel-drawer': {
                position: 'relative',
                right: '0'
            },
        },
        users: {
            '& .MuiTypography-root': {
                width: '100%',
                fontSize: '12px',
                color: colors.color13,
            },
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
            '&.flex-j-e': {
                justifyContent: 'end',
            },
            '&.flex-j-sb': {
                justifyContent: 'space-between',
            },
            '&.wrap': {
                flexWrap: 'wrap',
            },
            '&.f-w': {
                width: '100%',
            },
            '&.g-1': {
                gap: '4px',
            },
            '&.g-2': {
                gap: '8px',
            },
        },
        section: {
            marginBottom: '32px',
        },
        check: {
            fontSize: '12px',
            color: colors.color8,
            position: 'absolute',
            top: '2px',
            right: '3px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        errorsText: {
            '&.MuiTypography-root': {
                width: '100%',
                color: colors.color19,
                fontSize: '10px',
            },
        },
        tableText: {
            fontSize: '12px',
            color: colors.color13,
        },
        scheduleIcon: ({ mark, color }: { mark: boolean, color?: string }) => {
            if (!!mark) {
                return {
                    color: color ?? colors.color4,
                    fontWeight: '600',
                    textShadow: `0px 0px 10px ${colors.color4}`,
                    position: 'relative',
                }
            }

            return {
                ...!!color && { color }
            }
        },
        scheduleTitle: {
            fontSize: '14px',
            fontWeight: '500',
            color: colors.color16,
        },
        subTitle: {
            fontSize: '16px',
            fontWeight: '600',
            color: colors.color26,
            margin: '10px 0',
        },
        formLabel: {
            '& .MuiFormControlLabel-label': {
                fontSize: '.8em'
            }
        },
        title: {
            flexGrow: 1,
            fontSize: '20px',
            fontWeight: '500',
        },
        circle: {
            width: '3px',
            height: '3px',
            backgroundColor: colors.color13,
            borderRadius: '50%',
        },
        textList: {
            display: 'flex',
            // alignItems: 'start',
            // gap: 1,
            //mt: 0.5,
            textAlign: 'start',
            fontSize:'12px',
            width: '100%',
        },
        containerCircle: {
            minWidth: '10px',
            paddingTop: 0.7
        },
    }
}

export { useStyles }
